import { Doughnut } from "react-chartjs-2";
import React, { useEffect, useState } from "react";
import app from "../util/firebase";
import {
  getDatabase,
  ref,
  set,
  update,
  push,
  orderByChild,
  equalTo,
  query,
  remove,
  onValue,
} from "firebase/database";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  LinearProgress,
  useTheme,
} from "@mui/material";
import AssignmentLateOutlinedIcon from "@mui/icons-material/AssignmentLateOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";

export const Progress = (props) => {
  const db = getDatabase(app);
  const [totalSittingTime, setTotalSittingTime] = useState(0);
  const [timeStamp, setTimeStamp] = useState(new Date().getTime());
  const [timePercent, setTimePercent] = useState(0);
  const [timeSpan, setTimeSpan] = useState(0);
  const [completeCount, setCompleteCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const totalCountRef = query(ref(db, "da6d/" + "totalCount"));
  const completeCountRef = query(ref(db, "da6d/" + "completeCount"));
  const da6dRef = query(ref(db, "da6d"));
  const motionNotificationRef = query(ref(db, "da6d/" + "motion"));
  const totalSittingTimeRef = query(
    ref(db, "da6d/" + "motion/" + "totalSittingTime")
  );
  const timeStampRef = query(ref(db, "da6d/" + "motion/" + "timeStamp"));
  const timePercentRef = query(ref(db, "da6d/" + "motion/" + "timePercent"));

  useEffect(() => {
    onValue(totalCountRef, (snapshot) => {
      setTotalCount(snapshot.val());
    });
    onValue(timeStampRef, (snapshot) => {
      setTimeStamp(snapshot.val());
      console.log("last 2 time stamp is " + new Date(snapshot.val()));
      console.log("timeStamp is" + new Date(timeStamp));
    });
    onValue(totalSittingTimeRef, (snapshot) => {
      var nowTimeStamp = timeStamp;
      setTotalSittingTime(snapshot.val());
      onValue(timeStampRef, (snapshot) => {
        // setTimeStamp(snapshot.val());
        // console.log("last 2 time stamp is " + new Date(snapshot.val()));
        // console.log("timeStamp is" + new Date(timeStamp));
        nowTimeStamp = snapshot.val();
      });
      const currentTimeStamp = new Date().getTime();
      // console.log("time span " + (currentTimeStamp - timeStamp) / 60000);
      console.log("total sitting " + snapshot.val());
      console.log("time span is " + (currentTimeStamp - nowTimeStamp) / 60000);

      update(motionNotificationRef, {
        timePercent: Math.round(
          (snapshot.val() * 100) / ((currentTimeStamp - nowTimeStamp) / 60000)
        ),
      });
      setTimePercent(
        Math.round(
          (snapshot.val() * 100) / ((currentTimeStamp - nowTimeStamp) / 60000)
        )
      );
    });
    // onValue(totalSittingTimeRef, (snapshot) => {
    //   setTotalSittingTime(snapshot.val());
    // });

    // onValue(timePercentRef, (snapshot) => {
    //   setTimePercent(snapshot.val());
    // });
    // onValue(motionNotificationRef, (snapshot) => {
    //   snapshot.forEach((childSnapshot) => {
    //     if (childSnapshot.key == "totalSittingTime") {
    //       setTotalSittingTime(childSnapshot.val());
    //       // console.log("sitting time is " + childSnapshot.val())
    //     } else if (childSnapshot.key == "timeStamp") {
    //       setTimeStamp(childSnapshot.val());
    //       // console.log(
    //       //   "time stamp difference is " +
    //       //     (new Date().getTime() - childSnapshot.val()) / 60000
    //       // );
    //     } else if (childSnapshot.key == "timePercent") {
    //       setTimePercent(childSnapshot.val());
    //       // console.log("time percentis " + childSnapshot.val());
    //     }
    //   });
    // });
    onValue(completeCountRef, (snapshot) => {
      setCompleteCount(snapshot.val());
    });
    return () => {
      setTotalCount();
      setCompleteCount();
    };
  }, []);
  ChartJS.register(ArcElement, Tooltip, Legend);
  const theme = useTheme();

  const data = {
    datasets: [
      {
        data: [totalCount - completeCount, completeCount],
        backgroundColor: ["#1E3877", "#0288d1"],
        borderWidth: 4,
        borderColor: "#F5F5F5",
        hoverBorderColor: "#C0C0C0",
      },
    ],
    labels: ["In Progress", "Complete"],
  };

  const options = {
    animation: true,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: "index",
      titleFontColor: theme.palette.text.primary,
    },
  };

  const devices = [
    {
      title: "Complete",
      value: completeCount,
      icon: AssignmentTurnedInOutlinedIcon,
      color: "#0288d1",
    },
    {
      title: "In Progress",
      value: totalCount - completeCount,
      icon: AssignmentLateOutlinedIcon,
      color: "#1E3877",
    },
  ];

  return (
    // <div>
    <Card {...props}>
      <CardHeader title="Progress" sx={{ textAlign: "center" }} />

      <CardContent>
        <Box
          sx={{
            height: 210,
            position: "relative",
          }}
        >
          <Doughnut data={data} options={options} />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            // pt: 1,
          }}
        >
          {devices.map(({ color, icon: Icon, title, value }) => (
            <Box
              key={title}
              sx={{
                p: 1,
                textAlign: "center",
              }}
            >
              <Icon color="action" />
              <Typography color="textPrimary" variant="body1">
                {title}
              </Typography>
              <Typography style={{ color }} variant="h4">
                {value}
              </Typography>
            </Box>
          ))}
        </Box>
        {/* <Divider />
        <div style={{ textAlign: "center" }}>
          <Typography color="textPrimary" variant="body1">
            You've been working for{" "}
            <Typography variant="h6">
              {totalSittingTime + " minutes"}
            </Typography>
            which occupies
            <Typography variant="h6">{timePercent + " %"}</Typography> of your
            time.
          </Typography>
        </div> */}
      </CardContent>
      {/* <Divider /> */}
    </Card>
  );
};
